import { USER_TYPE } from '../../utils/constants';
import { containsAnyKeys } from '../../utils/objectHelpers';

const columns = (
  renderActions,
  renderWellsNameEditCell,
  renderValueCell,
  renderValueNumberCell,
  renderRigNameEditCell,
  renderHydraulicCell,
  renderWellsFavoritesCell,
  renderWellsCustomersCell,
  user,
  RenderInputColumn
) => {
  const shouldHideCustomersColumn = !(
    user.type === USER_TYPE.PREMIUM_ADMIN ||
    user.type === USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN ||
    (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN &&
      containsAnyKeys([USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN], user.accessLevels))
  );

  return [
    {
      field: 'favorites',
      headerName: '',
      renderCell: renderWellsFavoritesCell,
      headerAlign: 'center',
      width: 80,
      align: 'center',
    },
    {
      field: 'customers',
      headerName: 'Customers',
      renderCell: renderWellsCustomersCell,
      hide: shouldHideCustomersColumn,
      headerAlign: 'center',
      width: 100,
      align: 'center',
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 340,
      editable: true,
      renderEditCell: renderWellsNameEditCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'rig',
      headerName: 'Rig',
      width: 340,
      renderEditCell: renderRigNameEditCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'operator',
      headerName: 'Operator',
      width: 210,
      renderEditCell: renderValueCell,
      headerAlign: 'center',
      editable: true,
      align: 'center',
    },
    {
      field: 'latitude',
      headerName: 'Latitude',
      width: 155,
      renderEditCell: renderValueNumberCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'longitude',
      headerName: 'Longitude',
      width: 155,
      renderEditCell: renderValueNumberCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'inputs',
      headerName: 'Inputs',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => <RenderInputColumn row={params?.row} />,
    },
    {
      field: 'hydraulic',
      headerName: 'Hydraulics',
      renderCell: renderHydraulicCell,
      headerAlign: 'center',
      width: 120,
      align: 'center',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 280,
      headerAlign: 'center',
      align: 'center',
      renderCell: renderActions,
    },
  ];
};

export default columns;
